import React from 'react';

import SearchBox, {SearchBoxType} from '@/views/search/SearchBox';


export const HeaderSearch = React.memo(() => (
    <SearchBox
        type={SearchBoxType.Header}
        controlId="headerSearchQuery"
        className="icon-input-group mx-auto mb-3"
        style={{
            display: 'block',
            width: '50%',
            top: '10px',
        }}
    />
));
